/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Lock: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="lock" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M717.7825 453.3475000000001V680.0000000000001H642.2175V453.3475000000001H717.7825zM453.305 1020V831.13H377.74C336.005 831.13 302.175 797.3000000000001 302.175 755.565V151.1300000000001H1057.74V755.565C1057.74 797.3 1023.91 831.13 982.175 831.13H906.61V1020C906.61 1145.2050000000002 805.1200000000001 1246.6525000000001 679.9575 1246.6525000000001S453.305 1145.1625000000001 453.305 1020zM831.0875 831.13H528.87V1020C528.87 1103.47 596.53 1171.13 680 1171.13S831.13 1103.47 831.13 1020V831.13zM377.7825 755.565H982.2174999999997V226.695H377.7824999999999V755.565z" : "M574.226 362.6780000000001V544.0000000000001H513.774V362.6780000000001H574.226zM362.644 816V664.904H302.192C268.804 664.904 241.74 637.84 241.74 604.452V120.904H846.1919999999999V604.452C846.1919999999999 637.8399999999999 819.1279999999999 664.904 785.74 664.904H725.288V816C725.288 916.164 644.0960000000001 997.322 543.966 997.322S362.644 916.1300000000002 362.644 816zM664.87 664.904H423.096V816C423.096 882.7760000000001 477.224 936.904 544 936.904S664.904 882.7760000000001 664.904 816V664.904zM302.226 604.452H785.7739999999999V181.356H302.226V604.452z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Lock.displayName = `Blueprint5.Icon.Lock`;
export default Lock;
